export const ResearchResponsibleCrubs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Pratiche',
    path: '/pratiche',
  },
  {
    name: 'Ricerca Responsabile',
    path: '/pratiche/ricerca-responsabile',
  },
];

export const NewResponsibleCrubs = [
  ...ResearchResponsibleCrubs,
  {
    name: 'Nuovo Responsabile',
    path: '/pratiche/ricerca-responsabile/nuovo',
  },
];

export const EditResponsibleCrubs = [
  ...ResearchResponsibleCrubs,
  {
    name: 'Modifica Responsabile',
    path: '/pratiche/ricerca-responsabile/modifica',
  },
];

export const DetailResponsibleCrubs = [
  ...ResearchResponsibleCrubs,
  {
    name: 'Dettaglio Responsabile',
    path: '/pratiche/ricerca-responsabile/dettaglio',
  },
];
